import { useStore } from '@/store';

export const useIsLoadingWithDelay = (delay = 1000) => {
  const store = useStore();
  const setIsLoading = (value: boolean) => store.dispatch.internal.update(['isLoading', value]);
  const timeout = setTimeout(() => setIsLoading(true), delay);

  return () => {
    clearTimeout(timeout);
    setIsLoading(false);
  };
};
